import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuickSearchService {

  constructor() { }

  private _isQuickSearchOpen: boolean = false;
  private _isCloseAnimation: boolean = false


  public get isQuickSearchOpen() : boolean {
    return this._isQuickSearchOpen;
  }

  public get isCloseAnimation(): boolean{
    return this._isCloseAnimation
  }

  public openQuicksearch(){
    this._isQuickSearchOpen = true
  }

  public closeQuickSearch(){
    this._isCloseAnimation = true
    setTimeout(() => {
      this._isCloseAnimation = false
      this._isQuickSearchOpen = false
    }, 150);
  }



}
